import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import CartPageFooter from 'bento-ordering/cart/containers/CartPageFooter';
import BaseLayout from 'bento-ordering/base/layouts/BaseLayout';
import { DEFAULT_LAYOUT_PADDING } from 'styles/constants/layoutPadding';
import { useIsMobile } from 'styles/hooks/mediaQueries';
import ConfirmContainer from 'bento-ordering/base/containers/ConfirmContainer';
import CartConfirmModal from 'bento-ordering/cart/components/CartConfirmModal';
import MobileFooter from 'bento-ordering/base/components/MobileFooter';

import { CART_LAYOUT_ID } from 'constants/layout';

const CartPageLayout = ({ children, heroImage, isFetching }) => {
  const isMobile = useIsMobile();

  return (
    <BaseLayout
      isFetching={isFetching}
      hideBrandFooterOnMobile
      hideHeroOnMobile
      hideNav={isMobile}
      isModal
      mobileFooter={
        <ConfirmContainer>
          {(isOpen, modalType, toggleIsOpen) => (
            <React.Fragment>
              {!isOpen && <CartPageFooter toggleIsOpen={toggleIsOpen} />}
              {isOpen && (
                <MobileFooter>
                  <CartConfirmModal
                    toggleIsOpen={toggleIsOpen}
                    modalType={modalType}
                  />
                </MobileFooter>
              )}
            </React.Fragment>
          )}
        </ConfirmContainer>
      }
      layoutPadding={{ ...DEFAULT_LAYOUT_PADDING, pb: 9, pt: 2.5 }}
      heroImage={heroImage}
      id={CART_LAYOUT_ID}
      shouldUseMenuStyle={!isMobile}
    >
      {children}
    </BaseLayout>
  );
};

CartPageLayout.propTypes = {
  children: PropTypes.object,
  isFetching: PropTypes.bool,
  heroImage: PropTypes.object
};

const mapStateToProps = state => {
  const { menu } = state;
  const image = get(menu, 'images[0]', {});
  return {
    isFetching: menu.isFetching,
    heroImage: image
  };
};

export default connect(mapStateToProps)(CartPageLayout);
